/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Fulfillment_Not_Ready_For_ReleaseInputs */

const en_error_fulfillment_not_ready_for_release = /** @type {(inputs: Error_Fulfillment_Not_Ready_For_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The shipment cannot go to the warehouse yet: Business Central has not issued its invoice or proforma.`)
};

/**
* | output |
* | --- |
* | "The shipment cannot go to the warehouse yet: Business Central has not issued its invoice or proforma." |
*
* @param {Error_Fulfillment_Not_Ready_For_ReleaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_fulfillment_not_ready_for_release = /** @type {((inputs?: Error_Fulfillment_Not_Ready_For_ReleaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Fulfillment_Not_Ready_For_ReleaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_fulfillment_not_ready_for_release(inputs)
});